var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-card',[_c('h5',[_vm._v("Campaigns")]),_c('tracker-campaign-table',{attrs:{"company":_vm.company,"campaigns":_vm.campaigns}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }